// src/models/organizationModels.js - 基本構造（エラー解決用）

// デフォルト組織
export const defaultOrganization = {
    id: 'default-org',
    name: 'デフォルト組織',
    type: 'hospital',
    members: [],
    settings: {
      timezone: 'Asia/Tokyo',
      language: 'ja'
    }
  };
  
  // 組織タイプ
  export const OrganizationTypes = {
    hospital: {
      name: '病院',
      description: '総合病院・大学病院など',
      defaultMaxStaff: 200
    },
    clinic: {
      name: 'クリニック', 
      description: '診療所・小規模医院など',
      defaultMaxStaff: 50
    },
    group: {
      name: '医療グループ',
      description: '複数の医療機関を統括する組織',
      defaultMaxStaff: 500
    }
  };
  
  // 権限設定
  export const getRolePermissions = (role) => {
    const permissions = {
      owner: [
        'org:read', 'org:write', 'org:delete', 'org:manage_users',
        'staff:read', 'staff:write', 'staff:delete', 'staff:manage',
        'schedule:read', 'schedule:write', 'schedule:delete',
        'surgery:read', 'surgery:write', 'surgery:delete',
        'report:read', 'report:generate',
        'settings:read', 'settings:write'
      ],
      admin: [
        'org:read', 'org:write', 'org:manage_users',
        'staff:read', 'staff:write', 'staff:manage',
        'schedule:read', 'schedule:write', 'schedule:delete',
        'surgery:read', 'surgery:write', 'surgery:delete',
        'report:read', 'report:generate',
        'settings:read', 'settings:write'
      ],
      manager: [
        'org:read',
        'staff:read', 'staff:write',
        'schedule:read', 'schedule:write',
        'surgery:read', 'surgery:write',
        'report:read'
      ],
      staff: [
        'org:read',
        'staff:read',
        'schedule:read',
        'surgery:read',
        'report:read'
      ]
    };
    
    return permissions[role] || permissions.staff;
  };
  
  // organizationService.js用の仮実装（エラー回避用）
  export const OrganizationModel = {
    createDefault: (name, type = 'hospital') => ({
      name: name,
      type: type,
      settings: {
        timezone: 'Asia/Tokyo',
        language: 'ja',
        maxStaff: 100
      },
      createdAt: new Date(),
      isActive: true
    }),
    
    validate: (organization) => ({
      isValid: true,
      errors: []
    })
  };
  
  export const UserOrganizationModel = {
    createDefault: (userId, organizationId, role = 'staff') => ({
      userId: userId,
      organizationId: organizationId,
      role: role,
      permissions: getRolePermissions(role),
      joinedAt: new Date(),
      isActive: true
    }),
    
    hasPermission: (userOrg, permission) => {
      return userOrg.isActive && userOrg.permissions.includes(permission);
    },
    
    isAdmin: (userOrg) => {
      return userOrg.isActive && ['owner', 'admin'].includes(userOrg.role);
    }
  };
  
  export const MigrationUtils = {
    createDefaultOrganization: () => ({
      id: 'default-hospital',
      name: 'メイン病院',
      type: 'hospital',
      settings: {
        timezone: 'Asia/Tokyo',
        language: 'ja',
        maxStaff: 100
      },
      createdAt: new Date(),
      isActive: true,
      isDefault: true
    }),
    
    createDefaultUserOrganization: (userId) => ({
      userId: userId,
      organizationId: 'default-hospital',
      role: 'admin',
      permissions: getRolePermissions('admin'),
      joinedAt: new Date(),
      isActive: true,
      isMigrated: true
    })
  };